'use strict';

angular.module('TurneroApp').component('coAgendaPaso3', {
    bindings: {
        centroAtencionSeleccionado: '<',
        ctrlPadre: '='
    },
    controller: [
        '$scope',
        '$rootScope',
        'agendaService',
        'TurneroAppConstant',
        'utilsService',
        'grupoUsuarioService',
        '$element',
        function ($scope, $rootScope, agendaService, TurneroAppConstant, utilsService, grupoUsuarioService, $element) {
            var ctrl = this;
            ctrl.Estados = TurneroAppConstant.Estados.Agenda;
            ctrl.searchTerm = {
                text: '',
                seleccionado: false
            };

            ctrl.clearSearchTerm = function () {
                ctrl.searchTerm = {
                    text: '',
                    seleccionado: false
                };
            };
            ctrl.limpiarMemoria = function () {
                ctrl.Agenda = {
                    Id_Agenda: null,
                    Id_Usuario: '',
                    Id_Centro_Usuario_Alta: '',
                    Id_Autorizado_Agenda_Baja: '',
                    Id_Estado: 0
                };
                ctrl.grupoUsuario = {};
                ctrl.agenteSeleccionado = '';
                ctrl.grupoSeleccionado = '';
            };

            $scope.$on('inicioAgendaPaso3_load', function (event, obj) {
                ctrl.limpiarMemoria();
                ctrl.Agenda.Id_Agenda = obj.Id_Agenda;
                ctrl.agendaNueva = obj.isNew;
                if (ctrl.Agenda.Id_Agenda != null) {
                    utilsService.swalNotification('Cargando datos.', 'Obteniendo los usuarios autorizados para la agenda.', 'info');
                    agendaService.Get_Paso3({ 'Id_Agenda': ctrl.Agenda.Id_Agenda, 'Id_Centro_Atencion': ctrl.centroAtencionSeleccionado.id }).$promise.then(function (resultado) {
                        ctrl.Agenda = resultado.Data;
                        ctrl.Agenda.Id_Agenda = obj.Id_Agenda;
                        ctrl.Agenda.Id_Centro_Usuario_Alta = '';
                        ctrl.Agenda.Id_Autorizado_Agenda_Baja = '';
                        ctrl.Traer_Grupo_Usuarios_Activos_Combo();
                        //swal.close();
                    }).catch(function (error) {
                        utilsService.errores(error);
                        swal.close();
                    });
                }
                if (!ctrl.ctrlPadre.readOnly && ctrl.ctrlPadre.AutorizadosAgendaRequeridos) {
                    swal({
                        title: 'Validar',
                        text: 'Debe ingresar por lo menos un agente para poder continuar.',
                        type: 'warning',
                        confirmButtonText: 'Aceptar',
                        allowEscapeKey: false,
                        allowOutsideClick: false
                    });
                }

            });

            ctrl.Traer_Grupo_Usuarios_Activos_Combo = function () {
                grupoUsuarioService.Traer_Grupo_Usuarios_Activos_Combo({ 'Id_Centro_Atencion': ctrl.centroAtencionSeleccionado.id }).$promise.then(function (response) {
                    ctrl.grupoUsuario = response.Data;
                    swal.close();
                }).catch(function (error) {
                    utilsService.errores(error);
                    swal.close();
                });
            };

            // cambiar de vista. sobretodo para el boton atras.-
            ctrl.cambiarVista = function (funcion) {
                funcion(true, ctrl.Agenda.Id_Estado == TurneroAppConstant.Estados.Agenda.Pendiente, ctrl.Agenda.Id_Agenda);
            };

            ctrl.switchTab = function (paso, funcion) {
                var pasoActual = 1;
                if (ctrl.Agenda.Id_Estado == TurneroAppConstant.Estados.Agenda.Pendiente && pasoActual > paso) {
                    ctrl.cambiarVista(funcion);
                } else if (ctrl.Agenda.Id_Estado != TurneroAppConstant.Estados.Agenda.Pendiente) {
                    ctrl.cambiarVista(funcion);
                }
            };

            ctrl.cancelar = function (mostrarMensaje = false) {
                if (mostrarMensaje) {
                    ctrl.ctrlPadre.mostrarMensajeFinal();
                } else {
                    ctrl.limpiarMemoria();
                    ctrl.ctrlPadre.consultaAgendas(true);
                }
            };

            ctrl.guardarPaso3 = function (paso_siguiente) {
                if (ctrl.ctrlPadre.readOnly) {
                    ctrl.ctrlPadre.inicioAgendaPaso4(true, true, ctrl.Agenda.Id_Agenda);
                } else {
                    utilsService.swalTitle('Procesando datos.', 'info');
                    if (ctrl.validarForm()) {
                        if (ctrl.Agenda.Id_Agenda != null) {
                            agendaService.Put_Agenda_Paso3(({ 'id': ctrl.Agenda.Id_Agenda }, ctrl.Agenda)).$promise.then(function (result) {
                                swal.close();
                                ctrl.ctrlPadre.AutorizadosAgendaRequeridos = false;
                                if (paso_siguiente) {                                    
                                    ctrl.cambiarVista(ctrl.ctrlPadre.inicioAgendaPaso4);
                                } else {
                                    ctrl.cancelar(true);
                                }
                            }).catch(function (error) {
                                swal.close();
                                utilsService.errores(error);
                            })
                        }

                    }
                    swal.close();
                }
            };

            ctrl.eliminarItem = function (agente) {
                agente = angular.fromJson(agente);
                for (var i = 0; i < ctrl.Agenda.Usuarios.length; i++) {
                    if (ctrl.Agenda.Usuarios[i].id == agente.id) {
                        ctrl.Agenda.Usuarios[i].seleccionado = false;
                    }
                }
            };

            ctrl.agregarAgente = function (agente, contar = false) {
                agente = angular.fromJson(agente);
                for (var i = 0; i < ctrl.Agenda.Usuarios.length; i++) {
                    if (ctrl.Agenda.Usuarios[i].id == agente.id) {
                        if (contar && !ctrl.Agenda.Usuarios[i].seleccionado)
                            ctrl.UsuariosAgregados++;

                        ctrl.Agenda.Usuarios[i].seleccionado = true;
                        ctrl.agenteSeleccionado = '';
                    }
                }
            };

            ctrl.agregarGrupo = function (grupo) {
                ctrl.UsuariosAgregados = 0;
                grupo = angular.fromJson(grupo);
                for (var i = 0; i < grupo.usuarios.length; i++) {
                    var agente = {
                        id: grupo.usuarios[i].Id_Centro_Usuario,
                        text: grupo.usuarios[i].N_Usuario,
                        selecionado: false
                    };
                    ctrl.agregarAgente(agente, true);
                }
                ctrl.grupoSeleccionado = '';

                var msj = ctrl.UsuariosAgregados == 0 ? `Todo los agentes del grupo ${grupo.text} se encuentran asignados` : `Se agregaron ${ctrl.UsuariosAgregados} agente del grupo ${grupo.text}`;

                swal({
                    title: 'Información',
                    text: msj,
                    type: 'info',
                    confirmButtonText: 'OK',
                    allowEscapeKey: false,
                    allowOutsideClick: false
                });

            };

            ctrl.validarForm = function () {
                ctrl.Agenda.Id_Centro_Usuario_Alta = '';
                ctrl.Agenda.Id_Autorizado_Agenda_Baja = '';
                if (ctrl.Agenda.Usuarios && ctrl.Agenda.Usuarios.length > 0) {
                    var usuariosSeleccionados = false;
                    for (var i = 0; i < ctrl.Agenda.Usuarios.length; i++) {
                        var item = ctrl.Agenda.Usuarios[i];
                        //Nuevos
                        if ((item.Id_Seleccionado == '') && item.seleccionado) {
                            ctrl.Agenda.Id_Centro_Usuario_Alta = ctrl.Agenda.Id_Centro_Usuario_Alta == '' ? item.id : ctrl.Agenda.Id_Centro_Usuario_Alta + ',' + item.id
                        }
                        //Eliminados
                        if ((item.Id_Seleccionado != '') && !item.seleccionado) {
                            ctrl.Agenda.Id_Autorizado_Agenda_Baja = ctrl.Agenda.Id_Autorizado_Agenda_Baja == '' ? item.Id_Seleccionado : ctrl.Agenda.Id_Autorizado_Agenda_Baja + ',' + item.Id_Seleccionado
                        }
                        if (item.seleccionado) {
                            usuariosSeleccionados = true;
                        }
                    }
                    if (!usuariosSeleccionados) {
                        swal({
                            title: 'Error',
                            text: 'Debe seleccionar al menos un agente.',
                            type: 'warning',
                            confirmButtonText: 'Aceptar',
                            allowEscapeKey: false,
                            allowOutsideClick: false
                        });
                        return false;
                    }
                }
                else {
                    swal({
                        title: 'Error',
                        text: 'Debe seleccionar al menos un agente.',
                        type: 'warning',
                        confirmButtonText: 'Aceptar',
                        allowEscapeKey: false,
                        allowOutsideClick: false
                    });
                    return false;
                }
                return true;
            };

            $element.find('input').on('keydown', function (ev) {
                ctrl.searchTerm = ctrl.searchTerm
                ev.stopPropagation();
            });


            ctrl.buscarAgente = function (query) {

                var results = query ? ctrl.Agenda.Usuarios.filter(createFilterFor(query)) : ctrl.Agenda.Usuarios,
                    deferred;
                return results;

            };

            function createFilterFor(query) {
                var lowercaseQuery = angular.lowercase(query);

                return function filterFn(agente) {
                    return (agente.text.indexOf(lowercaseQuery) === 0);
                };

            }

        }
    ],
    template: require('./agenda_Paso3.html')
});



// WEBPACK FOOTER //
// ./app/components/agenda/agenda_Paso3Component.js